import { AlertIcon, Flex, Typography } from '@iheartjane/reefer';

import styles from './productDetailAlert.module.css';

export function ProductDetailAlert({ label }: { label: string }) {
  return (
    <Flex className={styles['toastContainer']}>
      <AlertIcon color="grays-white" />
      <Typography color="grays-white" variant="body-semibold">
        {label}
      </Typography>
    </Flex>
  );
}
